function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom.iterable.js";
/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isNonCachedRoute } from "../js/util.js";
import ExperienceContext from "./ExperienceContext.js";
const ExperienceProvider = _ref => {
  let {
    value,
    children,
    disableLocalization = false
  } = _ref;
  const isServer = !(typeof window !== 'undefined' && window.document && window.document.createElement);
  let initialDeliveryZipValue = null;
  if (isNonCachedRoute(value.path)) {
    initialDeliveryZipValue = value.deliveryZip;
  }
  const [store, setStore] = useState(null);
  const [deliveryZip, setDeliveryZip] = useState(initialDeliveryZipValue);
  const [nearByStores, setNearByStores] = useState([]);
  const [adobeCookie, setAdobeCookie] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [nativeFlags, setNativeFlags] = useState({});
  const cntx = {
    isServer,
    cookie: value.cookie,
    channel: value.channel,
    configService: value.configService,
    hosts: value.hosts,
    path: value.path,
    store: value.store,
    clientStore: value.clientStore,
    segment: value.segment,
    dataType: value.dataType,
    isDebugMode: typeof value.isDebugMode !== 'undefined' ? value.isDebugMode : false,
    isLocal: value.isLocal,
    customer: value.customer,
    localStoreZip: value.localStoreZip,
    deliveryZip,
    isConsumerApp: value.isConsumerApp,
    mounted,
    nativeFlags,
    nearByStores,
    referer: value.referer,
    experiment: value.experiment
  };
  const handleVisibilityChange = () => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('page.visibilitychange');
  };
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  useEffect(() => {
    var _window, _window$THD_LOCALIZER;
    const Localizer = (_window = window) === null || _window === void 0 ? void 0 : (_window$THD_LOCALIZER = _window.THD_LOCALIZER_AUTO_INIT) === null || _window$THD_LOCALIZER === void 0 ? void 0 : _window$THD_LOCALIZER.Localizer;
    const localize = Localizer === null || Localizer === void 0 ? void 0 : Localizer.localize;
    const {
      DELIVERY_ZIP_UPDATED,
      LOCALIZED
    } = (Localizer === null || Localizer === void 0 ? void 0 : Localizer.event) || {};
    if (!localize || disableLocalization) {
      return;
    }
    const expHandleLocalization = methods => {
      const newStore = methods === null || methods === void 0 ? void 0 : methods.getLocalizedStore();
      const newDeliveryZip = Localizer.getDeliveryZipcodeDetails().zipcode;
      if (newStore) {
        setStore({
          storeHours: newStore.storeHours,
          storeId: newStore.storeId,
          storeName: newStore.name,
          storeZip: newStore.zipcode
        });
      }
      if (newDeliveryZip) setDeliveryZip(newDeliveryZip);
      return methods;
    };
    localize().then(expHandleLocalization);
    const deliveryZipCallback = _ref2 => {
      let {
        output
      } = _ref2;
      const newDeliveryZip = output === null || output === void 0 ? void 0 : output.deliveryZip;
      if (newDeliveryZip && newDeliveryZip !== deliveryZip) {
        setDeliveryZip(newDeliveryZip);
        const {
          updateDeliveryZipcodeDetails
        } = Localizer || {};
        if (updateDeliveryZipcodeDetails) {
          updateDeliveryZipcodeDetails(newDeliveryZip);
        }
      }
    };
    const nearByStoresCallback = _ref3 => {
      let {
        output
      } = _ref3;
      const updatedNearByStores = output === null || output === void 0 ? void 0 : output.nearByStores;
      if (updatedNearByStores) setNearByStores(updatedNearByStores);
    };
    const storeInfoCallback = _ref4 => {
      var _window$THD_LOCALIZER2;
      let {
        output
      } = _ref4;
      const newStoreId = output === null || output === void 0 ? void 0 : output.storeID;
      const nativeNearByStores = output === null || output === void 0 ? void 0 : output.nearByStores;
      setNearByStores(nativeNearByStores);
      const {
        getLocalizedStore
      } = ((_window$THD_LOCALIZER2 = window.THD_LOCALIZER_AUTO_INIT) === null || _window$THD_LOCALIZER2 === void 0 ? void 0 : _window$THD_LOCALIZER2.Localizer) || {};
      if (newStoreId && newStoreId !== getLocalizedStore().storeId) {
        localize({
          storeId: newStoreId
        }).then(expHandleLocalization).then(() => {
          window.location.reload();
        });
      }
    };
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('experience-context.ready', cntx);
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NATIVE_APP.STORE_INFO', storeInfoCallback);
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NEARBY_STORES.update', nearByStoresCallback);
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NATIVE_APP.DELIVERY_ZIP', deliveryZipCallback);
    Localizer.on([DELIVERY_ZIP_UPDATED, LOCALIZED], expHandleLocalization);
    return () => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.off('NATIVE_APP.STORE_INFO', storeInfoCallback);
      LIFE_CYCLE_EVENT_BUS.lifeCycle.off('NEARBY_STORES.update', nearByStoresCallback);
      LIFE_CYCLE_EVENT_BUS.lifeCycle.off('NATIVE_APP.DELIVERY_ZIP', deliveryZipCallback);
      Localizer.off([DELIVERY_ZIP_UPDATED, LOCALIZED], expHandleLocalization);
    };
  }, []);
  useEffect(() => {
    try {
      var _window$THDCustomer, _window$THDCustomer$d;
      const mcsvid = (_window$THDCustomer = window.THDCustomer) === null || _window$THDCustomer === void 0 ? void 0 : (_window$THDCustomer$d = _window$THDCustomer.default) === null || _window$THDCustomer$d === void 0 ? void 0 : _window$THDCustomer$d.mcvisID;
      const ADOBE_COOKIE = {
        MCMID: mcsvid
      };
      setAdobeCookie(ADOBE_COOKIE);
    } catch (error) {
      setAdobeCookie({});
    }
  }, []);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (value.isConsumerApp) {
      const setNativeAppFlagsCallback = _ref5 => {
        let {
          output
        } = _ref5;
        const newNativeFlags = output === null || output === void 0 ? void 0 : output.nativeFlags;
        setNativeFlags(_objectSpread(_objectSpread({}, nativeFlags || {}), newNativeFlags || {}));
      };
      LIFE_CYCLE_EVENT_BUS.on('setNativeAppFlags', setNativeAppFlagsCallback);
      return () => {
        LIFE_CYCLE_EVENT_BUS.off('setNativeAppFlags', setNativeAppFlagsCallback);
      };
    }
  }, [value.isConsumerApp, nativeFlags]);
  if (store) {
    cntx.clientStore = store;
  }
  if (nearByStores) {
    cntx.nearByStores = nearByStores;
  }
  if (adobeCookie) {
    if (!cntx.cookie) {
      cntx.cookie = {};
    }
    cntx.cookie.adobeCookie = adobeCookie;
  }
  return /*#__PURE__*/React.createElement(ExperienceContext.Provider, {
    value: cntx
  }, children);
};
ExperienceProvider.propTypes = {
  value: PropTypes.shape([PropTypes.any, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  disableLocalization: PropTypes.bool
};
ExperienceProvider.defaultProps = {
  value: null,
  children: null,
  disableLocalization: false
};
export default ExperienceProvider;
//# sourceMappingURL=ExperienceProvider.js.map